import styled from "styled-components"

const GridContainer = styled.div`
  position: relative;
  display: block;
  margin: 10px 0;
  height: ${props => (props.height ? `${props.height}px` : "auto")};
`

export default GridContainer



// WEBPACK FOOTER //
// ./src/UI/GridView/GridContainer.js